import { ComponentNotificationBody } from "@fixa/notifications";
import TaskNotificationBodyAssignedOptionCount from "./TaskNotificationBodyAssignedOptionCount";
import TaskNotificationBodyAssignedProduct from "./TaskNotificationBodyAssignedProduct";
import TaskNotificationBodyAssignedTitle from "./TaskNotificationBodyAssignedTitle";
import TaskNotificationBodyOptionCount from "./TaskNotificationBodyOptionCount";
import TaskNotificationBodyProduct from "./TaskNotificationBodyProduct";
import TaskNotificationBodyTitleAndDescription from "./TaskNotificationBodyTitleAndDescription";

interface TaskNotificationBodyProps {
  component: ComponentNotificationBody;
  read: boolean;
}
const TaskNotificationBody = ({
  component,
  read,
}: TaskNotificationBodyProps): React.JSX.Element => {
  const { type } = component;
  switch (type) {
    case "notification-body-title-and-description":
      return (
        <TaskNotificationBodyTitleAndDescription {...component} read={read} />
      );
    case "notification-body-product":
      return <TaskNotificationBodyProduct {...component} read={read} />;
    case "notification-body-assigned-title":
      return <TaskNotificationBodyAssignedTitle {...component} read={read} />;
    case "notification-body-assigned-product":
      return <TaskNotificationBodyAssignedProduct {...component} read={read} />;
    case "notification-body-option-count":
      return <TaskNotificationBodyOptionCount {...component} read={read} />;
    case "notification-body-assigned-option-count":
      return (
        <TaskNotificationBodyAssignedOptionCount {...component} read={read} />
      );
  }
};

export default TaskNotificationBody;
